import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00.29</span> How technology is changing lives for the betterment of education?
                            </li>
                            <li><span>00:35</span> Guest introduction – Lillian Row.</li>
                            <li><span>01:13</span> Lillian Row's perspective on the pros and cons of modern
                                technology and its implementations in the school system.
                            </li>
                            <ul className="sub__list">
                                <li> - How implementing technology improves organizational effectiveness.</li>
                                <li> - How cloud-based platform enabled teachers and parents to get updated
                                    information.
                                </li>
                                <li> - How having a digital platform boosts organizational efficiency?</li>
                            </ul>
                            <li><span>03:36</span> <strong>Panelist Question #1</strong> – With technology being so prevalent, what took so long to get the educational institutes and students on this platform?</li>
                            <ul className="sub__list">
                                <li> - The reasons due to which technology was not implemented in organizations and
                                    schools.
                                </li>
                            </ul>
                            <li><span>03:36</span> <strong>Panelist Question #2</strong> – Does giving laptops to
                                students make everything balanced to enable students to adapt to the latest technology?
                            </li>
                            <ul className="sub__list">
                                <li> - Why giving laptops to students isn't enough to receive academic excellence.</li>
                            </ul>
                            <li><span>04:40</span> <strong>Panelist Question #3</strong> – In what ways we can
                                further bridge the technological gap to get everyone on the same page?
                            </li>
                            <ul className="sub__list">
                                <li> - Implementing professional development for teachers to help them understand how to
                                    leverage modern technology.
                                </li>
                                <li> - Taking the teacher's input/feedback on the viability of the implemented idea is
                                    important.
                                </li>
                                <li> - Leveraging the technology to support the basic principles of educations.</li>
                            </ul>
                            <li><span>11:52</span> How can technology be used to streamline the researching process
                                for students?
                            </li>
                            <li><span>12:05</span> <strong>Panelist Question #4</strong> – The barriers to using the
                                latest technologies and platforms. How can we better the usability and experience?
                            </li>
                            <ul className="sub__list">
                                <li> - Children break devices, and the best way to minimize this is by having an
                                    infrastructure that would support these devices.
                                </li>
                                <li> - The charging facility in the schools is important to ensure constant workflow or
                                    productivity.
                                </li>
                            </ul>
                            <li><span>16:28</span> <strong>Panelist Question #5</strong> – Is the idea of having an
                                infrastructure or technological advancements a part of Baltimore county's daily
                                discussions?
                            </li>
                            <ul className="sub__list">
                                <li> - How is Baltimore country supporting the cause of implementing technological
                                    advancements in the schooling system?
                                </li>
                                <li> - Having more reliable and affordable internet connection providers is essential.
                                </li>
                                <li> - Setting up a network the right way is more important than just having it.
                                </li>
                            </ul>
                            <li><span>21:45</span> Guest introduction – Coach Bilal
                            </li>
                            <li><span>22:41</span> Discussing the topic of technology used in education to improve
                                the process.
                            </li>
                            <ul className="sub__list">
                                <li> - How students communicate and operate before they access technological
                                    platforms?
                                </li>
                                <li> - How the Evolve Community Foundation identified the type of systems required to
                                    allow students to close gaps and prosper.
                                </li>
                                <li> - The revolutionary technology at Evolve foundation and educational benefits allow
                                    students/children to interact with these technologies.
                                </li>
                            </ul>
                            <li><span>27:00</span> What is the concept of the Beach Life System?
                            </li>
                            <ul className="sub__list">
                                <li> - A Beach Life System is an integrated system that helps students understand the
                                    mission and principles guidelines.
                                </li>
                                <li> - The abbreviation of B.E.A.C.H. (Business, Education, Arts, Community, Health.
                                </li>
                                <li> - B.E.A.C.H life is a holistic approach that teaches students and the community
                                    everything about the system.
                                </li>
                            </ul>
                            <li><span>31:58</span> <strong>Panelist Question #6</strong> – Is there any way for the
                                listeners to reach out to Lillian Row if they want to understand the technology's
                                ideology?
                            </li>
                            <ul className="sub__list">
                                <li> - Lillian Row shares her social media profiles and email info with the users.</li>
                            </ul>

                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;